export const SERVER_PATH = '';
export const ROOT_URL = `${SERVER_PATH}`;

// Login url
//post
export const LOGIN_URL = `${ROOT_URL}/apiv1/login`


// For Main Page
//get
export const USER_COUNT = `${ROOT_URL}/apiv1/reporting/account/count`
//get
export const CALL_COUNT = `${ROOT_URL}/callcount`

// For Account 
//post
export const ACCOUNT_CREATED = `${ROOT_URL}/apiv1/account`
//get
export const ACCOUNT_LISTING = `${ROOT_URL}/apiv1/account`
export const SPECIFIC_ACCOUNT_LISTING = `${ROOT_URL}/apiv1/account`

export const ACCOUNT_DASHBOARD_API = `${ROOT_URL}/apiv1/reporting/account/dashboard`
export const ACCOUNT_DELETE = `${ROOT_URL}/apiv1/account`

//update account
export const Account_Update = `${ROOT_URL}/apiv1/account`

//change status
export const Account_STATUS_CHANGE = `${ROOT_URL}/admin/apiv1/account`

// For Add_additonal_info_account
//For Billing
//post
// export const BILLING_CREATED = `${ROOT_URL}/admin/apiv1/account`
export const BILLING_CREATED = `${ROOT_URL}/apiv1/account`
//get
//export const BILLING_LISTING = `${ROOT_URL}/admin/apiv1/account`
export const BILLING_LISTING = `${ROOT_URL}/apiv1/account`

//ServerConnfig
//post
export const SERVER_CREATED = `${ROOT_URL}/apiv1/account`
//get
export const SERVER_LISTING = `${ROOT_URL}/apiv1/account`

export const DELETE_SERVER_URL = `${ROOT_URL}/apiv1/account`
export const UPDATE_SERVER_URL = `${ROOT_URL}/apiv1/account`

//Call_logs
//post

//get
export const CALL_LOG_LISTING = `${ROOT_URL}/apiv1/account`


// carrier restriction of account
export const CARRIER_RESTRICTION_ACCOUNT = `${ROOT_URL}/apiv1/routing/account`
export const CARRIER_RESTRICTION_ACCOUNT_UPDATE = `${ROOT_URL}/apiv1/routing/account`

export const CARRIER_RESTRICTION_USER = `${ROOT_URL}/apiv1/carrier`
export const CARRIER_RESTRICTION_USER_UPDATE = `${ROOT_URL}/apiv1/carrier`



//Balance ADD
//post
export const BALANCE_ADD = `${ROOT_URL}/apiv1/account`
//get

export const ACCOUNT_ACTIVITY_URL = `${ROOT_URL}/apiv1/account`

export const CARRIER_UPDATE = `${ROOT_URL}/apiv1/carrier`
export const CARRIER_DELETE = `${ROOT_URL}/apiv1/carrier`
export const CARRIER_LISTING = `${ROOT_URL}/apiv1/carrier`
export const SPECIFIC_CARRIER_LISTING = `${ROOT_URL}/apiv1/carrier`

export const CARRIER_DASHBOARD_API = `${ROOT_URL}/apiv1/reporting/carrier/dashboard`

export const CARRIER_ADD = `${ROOT_URL}/apiv1/carrier`


export const SERVER_TOGGAL = `${ROOT_URL}/admin/apiv1/account`
export const CARRIER_TOGGAL = `${ROOT_URL}/account`

// Stats 
export const ALL_STATS = `${ROOT_URL}/apiv1/reporting/live/calls`
export const CARRIER_STATS = `${ROOT_URL}/carrierstats`
export const ACCOUNT_STATS = `${ROOT_URL}/userstats`

export const TABLE_STATS = `${ROOT_URL}/apiv1/reporting/account/stats`

export const CARRIER_TABLE_STATS = `${ROOT_URL}/apiv1/reporting/carrier/stats`

export const SYSTEM_STATS = `${ROOT_URL}/apiv1/reporting/system/stats`
export const ALL_CARRIER_LIST = `${ROOT_URL}/apiv1/carriers/all`
export const ALL_ACCOUNT_LIST = `${ROOT_URL}/apiv1/accounts/all`

export const RATEDECK_LIST = `${ROOT_URL}/apiv1/ratedeck/list`

export const DOWNLOAD_PCAP = `${ROOT_URL}/apiv1/billing/pcap/cdrs`


export const ACCOUNT_STATS_PER_DAY = `${ROOT_URL}/apiv1/reporting/outbound/byday/account`

export const CARRIER_STATS_PER_DAY = `${ROOT_URL}/apiv1/reporting/outbound/byday/carrier`


// routing apis

//get
export const CALL_RESTRICTION_LISTING = `${ROOT_URL}/apiv1/routing/call-restriction`

//post
export const CALL_RESTRICTION_CREATING = `${ROOT_URL}/apiv1/routing/call-restriction/create`

//Delete
export const CALL_RESTRICTION_DELETE = `${ROOT_URL}/apiv1/routing/call-restriction`
export const CALL_RESTRICTION_CLEANUP_PREVIEW = `${ROOT_URL}/apiv1/routing/call-restriction/cleanup-preview`
export const CALL_RESTRICTION_CLEANUP = `${ROOT_URL}/apiv1/routing/call-restriction/cleanup`

// Report Download
export const DOWNLOAD_REPORT_URL = `${ROOT_URL}/apiv1/billing/reports/usage/export`

export const MEDIA_IP_BLOCK_LISTING = `${ROOT_URL}/apiv1/media/ip/block`


// report balance
export const REPORT_BALANCE = `${ROOT_URL}/apiv1/billing/reports/usage`

// gateway 
export const GATEWAY_LISTING = `${ROOT_URL}/apiv1/carrier`
export const GATEWAY_CREATE = `${ROOT_URL}/apiv1/carrier`
export const GATEWAY_DELETE = `${ROOT_URL}/apiv1/carrier/gateway`
export const GATEWAY_UPDATE = `${ROOT_URL}/apiv1/carrier/gateway`

//billing

export const BILLING_CDR_URL = `${ROOT_URL}/apiv1/billing`

//Plus Stats
export const PLUS_ACCOUNT_STATS = `${ROOT_URL}/apiv1/reporting/stats/history/account`
export const PLUS_CARRIER_STATS = `${ROOT_URL}/apiv1/reporting/stats/history/carrier`

// Agents api

export const GET_AGENTS_LIST = `${ROOT_URL}/apiv1/agent`;
export const CREATE_AGENT = `${ROOT_URL}/apiv1/agent`;
export const DELETE_AGENT_FROM_MAIN_LIST = `${ROOT_URL}/apiv1/agent`
export const UPDATE_AGENT_FROM_MAIN_LIST = `${ROOT_URL}/apiv1/agent`

export const GET_AGENT_AGAINST_USER = `${ROOT_URL}/apiv1/account`
export const ASSIGN_AGENT_CUSTOMER = `${ROOT_URL}/apiv1/account`


// export const CREATE_AGENTS_LIST = `${ROOT_URL}/apiv1/agent`;

export const RATEDECK_LISTING = `${ROOT_URL}/apiv1/ratedeck`
export const RATEDECK_UPLOAD_FILE = `${ROOT_URL}/apiv1/ratedeck/upload`
export const RATEDECK_COMPLETE = `${ROOT_URL}/apiv1/ratedeck/completed`
export const ASSIGN_RATEDECK = `${ROOT_URL}/apiv1/account`
export const GET_RATEDECK = `${ROOT_URL}/apiv1/account`


// Rate deck
export const CARRIER_RATEDECK_LIST = `${ROOT_URL}/apiv1/carrier`

export const CARRIER_RATEDECK_UPLOAD = `${ROOT_URL}/apiv1/carrier/ratedeck/upload`
export const ACCOUNT_RATEDECK_UPLOAD = `${ROOT_URL}/apiv1/account/ratedeck/upload`
export const ACCOUNT_RATEDECK_CANCEL = `${ROOT_URL}/apiv1/account/ratedeck/cancel`

export const ACCOUNT_RATEDECK_DOWNLOAD = `${ROOT_URL}/apiv1/account/ratedeck/download`
export const CARRIER_RATEDECK_DOWNLOAD = `${ROOT_URL}/apiv1/carrier/ratedeck/download`
export const CARRIER_RATEDECK_CANCEL = `${ROOT_URL}/apiv1/carrier/ratedeck/cancel`
export const CREATE_RATEDECK_NEW = `${ROOT_URL}/apiv1/ratedeck/create`

//Accounts => Product section
export const ACCOUNT_PRODUCT_LISTING = `${ROOT_URL}/apiv1/product`
export const ACCOUNT_PRODUCT_CREATE = `${ROOT_URL}/apiv1/product/create`
export const ACCOUNT_PRODUCT_UPDATE = `${ROOT_URL}/apiv1/product`

export const MONETARY_STATS_GRAPH = `${ROOT_URL}/apiv1/reporting/dashboard/monetary/stats`

export const INVOICE_LIST_API = `${ROOT_URL}/apiv1/invoice`
export const INVOICE_DOWNLOAD_API = `${ROOT_URL}/apiv1/invoice`
export const INVOICE_SEND_API = `${ROOT_URL}/apiv1/invoice`
export const INVOICE_EMAIL_HISTORY_API = `${ROOT_URL}/apiv1/invoice/email/history`

export const GET_ALL_ACCOUNTS = `${ROOT_URL}/apiv1/accounts/all`
export const GET_ALL_CARRIER = `${ROOT_URL}/apiv1/carriers/all`
export const CREATE_CALL_RESTRICTION = `${ROOT_URL}/apiv1/routing/call-restriction/create`


export const CREATE_RESTRICTION = `${ROOT_URL}/apiv1`

export const INVOICE_AGENT_LIST_API = `${ROOT_URL}/apiv1/agent/invoices`
    
export const FIND_ROUTE_CREATE_API = `${ROOT_URL}/apiv1/routing`

export const TRAFFIC_STATS_API = `${ROOT_URL}/apiv1/reporting/traffic/stats`
export const ENTITY_TRAFFIC_STATS_API = `${ROOT_URL}/apiv1/reporting/traffic/entity/stats`
export const ACCOUNT_CARRIER_LIVE_TRAFFIC_API = `${ROOT_URL}/apiv1/reporting/account-carrier/live`
export const CARRIER_MEDIA_STATS_API = `${ROOT_URL}/apiv1/reporting/carrier/media/stats`


// Accounts => Stir Shaken
export const ACCOUNT_TAB_STIR_SHAKEN = `${ROOT_URL}/apiv1/stirshaken/subject/block`
